import { DotLegalAlert, DotLegalCheckbox, DotLegalDialog, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { RiskAssessmentVersionArea, RiskVersionSaveModel } from "../riskAssessmentVersions/RiskAssessmentVersions.types";
import { Collapse } from "@mui/material";
import { useEditRiskVersionDialogHooks } from "./EditRiskAssessmentVersionDialog.hooks.ts";

export interface IEditRiskAssessmentVersionDialog {
    onDialogClose: () => void;
    selectedVersion: RiskVersionSaveModel;
    onVersionSaved: () => void;
}

export default function EditRiskAssessmentVersionDialog(props: IEditRiskAssessmentVersionDialog) {
    const { translateString } = useTranslation();
    const { inProgress, onSaveClick, version, modelUpdater, validation } = useEditRiskVersionDialogHooks(props);

    function getCurrentRiskLabel() {
        if (props.selectedVersion.area === RiskAssessmentVersionArea.GdprProcessingActivities) {
            return translateString("currentRiskGdprProcessingActivitiesWarning");
        } else if (props.selectedVersion.area === RiskAssessmentVersionArea.Nis2ProcessingActivities) {
            return translateString("currentRiskNis2ProcessingActivitiesWarning");
        } else if (props.selectedVersion.area === RiskAssessmentVersionArea.GdprSystems) {
            return translateString("currentRiskGdprAssetsWarning");
        } else {
            return translateString("currentRiskNis2AssetsWarning");
        }
    }

    validation.check(version);
    return (
        <DotLegalDialog
            buttonOkText={translateString("save")}
            header={translateString("editRiskVersion")}
            size="sm"
            open
            inProgress={inProgress}
            onDialogClose={() => props.onDialogClose()}
            onOkClick={() => onSaveClick()}
            disableBackdropOnCloseIfValueChange={version}
        >
            <DotLegalTextField
                label={translateString("name")}
                onChange={modelUpdater.onNameChange}
                value={version.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
            />
            <DotLegalTextField
                label={translateString("description")}
                onChange={modelUpdater.onDescriptionChange}
                value={version.description}
                debounce={false}
                multiline
                rows={5}
            />

            <DotLegalCheckbox label={translateString("currentRisk")} checked={version.isCurrent} onChange={modelUpdater.onIsCurrentChange} />

            <Collapse in={version.isCurrent}>
                <DotLegalAlert warningText={getCurrentRiskLabel()} />
            </Collapse>
        </DotLegalDialog>
    );
}
